import axios from "axios";
import { createMessage, createGenericErrorAlert } from "./messages";
import { tokenConfig } from "./auth";

import {
    GET_APPROVAL_WORKFLOWS,
    GET_APPROVAL_WORKFLOW,
    CREATE_APPROVAL_WORKFLOW,
    EDIT_APPROVAL_WORKFLOW,
    DELETE_APPROVAL_WORKFLOW,
    GET_APPROVAL_WORKFLOW_STAGES,
    SAVE_APPROVAL_WORKFLOW_STAGES,
    GET_WORKFLOW_STAGE_TYPES,
    DELETE_WORKFLOW_STAGE_TYPE,
    CLEAR_APPROVAL_WORKFLOW
} from "./types";

// GET the company's own Approval Workflow templates + the global ones
export const getApprovalWorkflows = () => (dispatch, getState) => {
    axios
        .get(`/v0/api/contract/workflow-template/`, tokenConfig(getState))
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }))
            } else {
                dispatch({ type: GET_APPROVAL_WORKFLOWS, payload: res.data });
            }
        })
        .catch((err) => dispatch(createGenericErrorAlert({...err.response.data, ...err.response.status})));
};

// GET one Approval Workflow template
export const getApprovalWorkflow = (uuid) => (dispatch, getState) => {
    axios
        .get(`/v0/api/contract/workflow-template/${uuid}/`, tokenConfig(getState))
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }))
            } else {
                dispatch({ type: GET_APPROVAL_WORKFLOW, payload: res.data });
            }
        })
        .catch((err) => dispatch(createGenericErrorAlert({...err.response.data, ...err.response.status})));
};

// CREATE a new Approval Workflow template -- returns a promise so the caller can chain the stages save once the uuid exists
export const createApprovalWorkflow = (workflow) => (dispatch, getState) => {
    return axios
        .post(`/v0/api/contract/workflow-template/`, workflow, tokenConfig(getState))
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }));
                return null;
            } else {
                dispatch({ type: CREATE_APPROVAL_WORKFLOW, payload: res.data });
                return res.data;
            }
        })
        .catch((err) => { dispatch(createGenericErrorAlert({...err.response.data, ...err.response.status})); return null; });
};

// EDIT (rename) an Approval Workflow template
export const editApprovalWorkflow = (uuid, workflow) => (dispatch, getState) => {
    return axios
        .put(`/v0/api/contract/workflow-template/${uuid}/`, workflow, tokenConfig(getState))
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }));
                return null;
            } else {
                dispatch({ type: EDIT_APPROVAL_WORKFLOW, payload: res.data });
                return res.data;
            }
        })
        .catch((err) => { dispatch(createGenericErrorAlert({...err.response.data, ...err.response.status})); return null; });
};

// DELETE an Approval Workflow template
export const deleteApprovalWorkflow = (uuid) => (dispatch, getState) => {
    axios
        .delete(`/v0/api/contract/workflow-template/${uuid}/`, tokenConfig(getState))
        .then((res) => {
            if (res.data && res.data.error) {
                dispatch(createMessage({ error: res.data.error }))
            } else {
                dispatch({ type: DELETE_APPROVAL_WORKFLOW, payload: uuid });
                dispatch(createMessage({ success: "Approval Workflow deleted." }));
            }
        })
        .catch((err) => dispatch(createGenericErrorAlert({...err.response.data, ...err.response.status})));
};

// GET a template's ordered stages
export const getApprovalWorkflowStages = (uuid) => (dispatch, getState) => {
    axios
        .get(`/v0/api/contract/workflow-template/${uuid}/stages`, tokenConfig(getState))
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }))
            } else {
                dispatch({ type: GET_APPROVAL_WORKFLOW_STAGES, payload: res.data });
            }
        })
        .catch((err) => dispatch(createGenericErrorAlert({...err.response.data, ...err.response.status})));
};

// SAVE (replace) a template's full ordered stage list in one call
export const saveApprovalWorkflowStages = (uuid, stages) => (dispatch, getState) => {
    return axios
        .put(`/v0/api/contract/workflow-template/${uuid}/stages`, { stages }, tokenConfig(getState))
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }));
                return null;
            } else {
                dispatch({ type: SAVE_APPROVAL_WORKFLOW_STAGES, payload: res.data });
                dispatch(createMessage({ success: "Approval Workflow saved." }));
                return res.data;
            }
        })
        .catch((err) => { dispatch(createGenericErrorAlert({...err.response.data, ...err.response.status})); return null; });
};

// GET the reusable stage-name catalog (own company + global)
export const getWorkflowStageTypes = () => (dispatch, getState) => {
    axios
        .get(`/v0/api/contract/workflow-stage-type/`, tokenConfig(getState))
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }))
            } else {
                dispatch({ type: GET_WORKFLOW_STAGE_TYPES, payload: res.data });
            }
        })
        .catch((err) => dispatch(createGenericErrorAlert({...err.response.data, ...err.response.status})));
};

// CREATE a new reusable stage name for this company's catalog (used inline while building a template)
export const createWorkflowStageType = (name) => (dispatch, getState) => {
    return axios
        .post(`/v0/api/contract/workflow-stage-type/`, { name }, tokenConfig(getState))
        .then((res) => {
            if (!res.data.error) {
                dispatch(getWorkflowStageTypes());
                dispatch(createMessage({ success: "Stage Name created." }));
            }
            return res.data;
        })
        .catch((err) => { dispatch(createGenericErrorAlert({...err.response.data, ...err.response.status})); return null; });
};

// DELETE a stage name from this company's own catalog (global names cannot be deleted)
export const deleteWorkflowStageType = (uuid) => (dispatch, getState) => {
    axios
        .delete(`/v0/api/contract/workflow-stage-type/${uuid}/`, tokenConfig(getState))
        .then((res) => {
            if (res.data && res.data.error) {
                dispatch(createMessage({ error: res.data.error }))
            } else {
                dispatch({ type: DELETE_WORKFLOW_STAGE_TYPE, payload: uuid });
                dispatch(createMessage({ success: "Stage Name deleted." }));
            }
        })
        .catch((err) => dispatch(createGenericErrorAlert({...err.response.data, ...err.response.status})));
};

export const clearApprovalWorkflow = () => (dispatch) => {
    dispatch({ type: CLEAR_APPROVAL_WORKFLOW });
};
